<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
    <button type="button" class="btn close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row pt-3 m-3 fw-bold font-18">
        {{ message }}
    </div>
</div>
<div class="modal-footer my-3">
    @if (cancelBtn) {
    <button (click)="activeModal.close(false)" type="submit" class="btn btn-footer {{ classCancelBtn }}">{{ cancelBtn }}</button>
    } @if (nextBtn) {
    <button (click)="activeModal.close(true)" type="submit" class="btn btn-footer {{ classConfirmBtn }}">{{ nextBtn }}</button>
    }
</div>
